import React from "react";
import { Navigate } from "react-router-dom";
import { getAuthToken } from "../../utils/authToken";

export const ProtectedRoute = ({ children }) => {
  if (getAuthToken()) {
    return <>{children}</>;
  }
  return <Navigate to="/logout" />;
};

export const UnprotectedRoute = ({ children }) => {
  if (!getAuthToken()) {
    return <>{children}</>;
  }
  return <Navigate to="/" />;
};

export const ExceptionRoute = ({ children }) => {
  if (!getAuthToken()) {
    return <Navigate to="/login" />;
  }
  return <Navigate to="/" />;
};
